"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentTermDaysValid = exports.isDiscountPeriodValid = exports.isDiscountPercentageValid = exports.isDiscountRuleValid = void 0;
const common_1 = require("../../common");
const vendorValidationConsts_1 = require("./vendorValidationConsts");
const isDiscountRuleValid = (discount) => {
    if (!discount) {
        return false;
    }
    return (0, exports.isDiscountPercentageValid)(discount.percentage) && (0, exports.isDiscountPeriodValid)(discount.period);
};
exports.isDiscountRuleValid = isDiscountRuleValid;
const isDiscountPercentageValid = (percentage) => {
    if ((0, common_1.isEmptyStringOrNullish)(percentage) || !(0, common_1.isNumeric)(percentage)) {
        return false;
    }
    const percentageNumber = Number(percentage);
    if (percentageNumber < vendorValidationConsts_1.MIN_DISCOUNT_PERCENTAGE || percentageNumber > vendorValidationConsts_1.MAX_DISCOUNT_PERCENTAGE) {
        return false;
    }
    return true;
};
exports.isDiscountPercentageValid = isDiscountPercentageValid;
const isDiscountPeriodValid = (period) => {
    if ((0, common_1.isEmptyStringOrNullish)(period) || !(0, common_1.isNumeric)(period)) {
        return false;
    }
    const periodNumber = Number(period);
    if (!Number.isInteger(periodNumber)) {
        return false;
    }
    if (periodNumber < vendorValidationConsts_1.MIN_DISCOUNT_DURATION_DAYS || periodNumber > vendorValidationConsts_1.MAX_DISCOUNT_DURATION_DAYS) {
        return false;
    }
    return true;
};
exports.isDiscountPeriodValid = isDiscountPeriodValid;
const isPaymentTermDaysValid = (days) => {
    if ((0, common_1.isEmptyStringOrNullish)(days) || !(0, common_1.isNumeric)(days)) {
        return false;
    }
    if (!Number.isInteger(Number(days))) {
        return false;
    }
    if (Number(days) < vendorValidationConsts_1.MIN_PAYMENT_TERM_DAYS || Number(days) > vendorValidationConsts_1.MAX_PAYMENT_TERM_DAYS) {
        return false;
    }
    return true;
};
exports.isPaymentTermDaysValid = isPaymentTermDaysValid;
